import {EstimateTreeOperationDto} from "../dtos/estimate-tree-operation.dto";
import {TreeOperationSchema} from "../../pages/estimate/estimate-tree.service";
import {areaEntries, areaSpecFor, areaSummaryLines, treeOperationDisplayLabel} from "../../pages/estimate/operation-areas.service";
import {InputDataType, InputSchema} from "./schema-based-inputs.service";
import {logError} from "./logger.service";
import { EstimateTreeDto } from "../dtos/estimate-tree.dto";

const getUnitString = (schema: InputSchema) => {
  if(schema.dataType === InputDataType.Percentage) {
    return '%';
  } else if(schema.unit) {
    return ` ${schema.unit}`;
  }
  return '';
}

// Keys removed from the schema by the AC-267 redesign but still present on
// operations saved by older app versions — display them without logging.
const legacyDetailDisplayNames: Record<string, {displayName: string, unit: string}> = {
  thinningPercentage: {displayName: 'Thinning Percentage', unit: '%'},
};

export const formatTreeOperationOneLine = (operation: EstimateTreeOperationDto) => {
  const areaSpec = areaSpecFor(operation.operationType);
  if(areaSpec) {
    const lines = areaSummaryLines(areaSpec, areaEntries(areaSpec, operation.details));
    return `${treeOperationDisplayLabel(operation.operationType)}${lines.length > 0 ? ` (${lines.join(', ')})` : ''}`;
  }
  // photoContext_* are the library's site observations (SQ-500), not something the line item says.
  const details = Object.keys(operation.details).filter(key => !key.startsWith('photoContext_')).map(key => {
    const schema = TreeOperationSchema[operation.operationType]?.find(schema => schema.name === key);
    if(!schema) {
      const legacy = legacyDetailDisplayNames[key];
      if(legacy) {
        return `${legacy.displayName}: ${operation.details[key]}${legacy.unit}`;
      }
      logError('Unknown operation detail when formatting tree operation', {operationType: operation.operationType, detailKey: key});
      return `${key}: ${operation.details[key]}`;
    }

    const displayName = schema?.displayName ?? key;
    const unitString = getUnitString(schema);
    return `${displayName}: ${operation.details[key]}${unitString}`
  }).join(', ');
  const detailString = Object.keys(operation.details).length > 0 ? ` (${details})` : '';
  return `${operation.operationType} ${detailString}`;
}

export const formatTree = (tree: EstimateTreeDto) => {
  return `${tree.species} (Height: ${tree.height}, Width: ${tree.width}, Trunk Diameter: ${tree.trunkDiameter})`;
}